/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Qbank_TitleInputs */

const en_interview_qbank_title = /** @type {(inputs: Interview_Qbank_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Question Bank`)
};

const de_interview_qbank_title = /** @type {(inputs: Interview_Qbank_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragenbank`)
};

const fr_interview_qbank_title = /** @type {(inputs: Interview_Qbank_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banque de questions`)
};

const es_interview_qbank_title = /** @type {(inputs: Interview_Qbank_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banco de preguntas`)
};

const it_interview_qbank_title = /** @type {(inputs: Interview_Qbank_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banca delle domande`)
};

const nl_interview_qbank_title = /** @type {(inputs: Interview_Qbank_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vragenbank`)
};

const pl_interview_qbank_title = /** @type {(inputs: Interview_Qbank_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bank pytań`)
};

const fi_interview_qbank_title = /** @type {(inputs: Interview_Qbank_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kysymyspankki`)
};

const da_interview_qbank_title = /** @type {(inputs: Interview_Qbank_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spørgsmålsbank`)
};

const sv_interview_qbank_title = /** @type {(inputs: Interview_Qbank_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frågebank`)
};

/**
* | output |
* | --- |
* | "Question Bank" |
*
* @param {Interview_Qbank_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_qbank_title = /** @type {((inputs?: Interview_Qbank_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Qbank_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_qbank_title(inputs)
	if (locale === "fr") return fr_interview_qbank_title(inputs)
	if (locale === "es") return es_interview_qbank_title(inputs)
	if (locale === "it") return it_interview_qbank_title(inputs)
	if (locale === "nl") return nl_interview_qbank_title(inputs)
	if (locale === "pl") return pl_interview_qbank_title(inputs)
	if (locale === "fi") return fi_interview_qbank_title(inputs)
	if (locale === "da") return da_interview_qbank_title(inputs)
	if (locale === "sv") return sv_interview_qbank_title(inputs)
	return en_interview_qbank_title(inputs)
});